import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Api } from '../enum/Api';

@Injectable()
export class DiscountModalService {


  private reachedTheModalTime: boolean = false;
  private clickedOnPackages: boolean = false;
  public discountModalConfig: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public discountIdentifierModal: BehaviorSubject<string> = new BehaviorSubject<string>("");


  constructor(
    private httpService: HttpService
  ) { }

  public setClickedOnPackages(value) {
    this.clickedOnPackages = value;
  }

  public getClickedOnPackages() {
    return this.clickedOnPackages;
  }

  public setdiscountIdentifierModal(identifier) {
    this.discountIdentifierModal.next(identifier);
  }

  public setReachedTheModalTime(value) {
    this.reachedTheModalTime = value;
  }

  public getReachedTheModalTime() {
    return this.reachedTheModalTime;
  }


  public setModalWasDisplayed(classificationIdentifier: string,userId: string, businessId: string, exhibitionPage: string, daysToDisplayAgain: number) {
    return this.httpService.post('serasa/discountModalConfig/setModalWasDisplayed', Api.One_Portal, {
      "classificationIdentifier": classificationIdentifier,
      "userId": userId,
      "businessId": businessId,
      "exhibitionPage": exhibitionPage,
      "daysToDisplayAgain": daysToDisplayAgain
    });
  }

  public setDiscoutModalConfig(discountModalConfig: any) {
    this.discountModalConfig.next(JSON.stringify(discountModalConfig));
  }

  public getDiscountModalConfigAPI(classificationIdentifier: string, userId: string, businessId: string) {
    return this.httpService.post('serasa/discountModalConfig/getConfigByClassification', Api.One_Portal, {
      "classificationIdentifier": classificationIdentifier,
      "userId": userId,
      "businessId": businessId
    });
  }
}
